import { Divert } from 'models/husqiotbus';

export function sortDiverts(diverts: Divert[]): Divert[] {
  const sortFunc = (a: Divert, b: Divert) => {
    if (a.serviceName > b.serviceName) {
      return 1;
    }
    if (a.serviceName < b.serviceName) {
      return -1;
    }
    return 0;
  };
  return diverts.slice().sort(sortFunc);
}
